/* src/app/home/trailer-request/request-rejection/request-rejection.component.scss */
.confirmation-text {
  color: #F68B20;
}
.attention-dropdown > select {
  border: 1px solid #F68B20 !important;
}
.btn-green {
  color: white;
  background-color: #00857D;
  border-radius: 35px;
  width: 117px;
  height: 36px;
  font-weight: 400;
  font-size: 13px;
  margin-top: 15px;
}
.request-rejection {
  display: flex;
  flex-direction: column;
  align-content: center;
  margin-bottom: 27px;
  min-width: 292px;
}
.request-rejection .selection {
  align-self: flex-start;
  text-align: left;
  width: 100%;
}
@media (min-width: 1880px) {
  .request-rejection {
    margin-bottom: 0px;
  }
  .request-rejection .reason {
    margin-bottom: 10px;
  }
  .request-rejection .selection {
    width: 360px;
  }
  .btn-green {
    margin-top: 24px;
  }
}
/*# sourceMappingURL=request-rejection.component.css.map */
